import React, { useCallback, useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { BenefitsSection } from '../components/BenefitsSection';
import { ControlSection } from '../components/ControlSection';
import { HowItWorks } from '../components/HowItWorks';
import { TechnologySection } from '../components/TechnologySection';
import { CredibilitySection } from '../components/CredibilitySection';
import { LeadFormSection } from '../components/LeadFormSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { BookingModal } from '../components/BookingModal';
import { heroVersions } from '../data/heroVersions';
import { useScrollDepth } from '../hooks/useScrollDepth';
import { scrollToId } from '../utils/scroll';
import { track } from '../utils/tracking';

/** Meta ad angle: A = independence, B = AI and follow-up, C = marketing, D = systems and support. */
export type AdVersion = 'A' | 'B' | 'C' | 'D';
interface LandingProps {
  adVersion: AdVersion;
  showStickyMobileCta: boolean;
}
export function Landing({
  adVersion,
  showStickyMobileCta
}: LandingProps) {
  const [bookingOpen, setBookingOpen] = useState(false);
  const copy = heroVersions[adVersion];
  useScrollDepth();
  const onFormCta = useCallback((source: string) => {
    if (source.startsWith('hero')) {
      track('hero_cta_click', {
        source
      });
    }
    scrollToId('lead-form');
  }, []);
  const onBookCall = useCallback((source: string) => {
    track('calendar_click', {
      source
    });
    setBookingOpen(true);
  }, []);
  return <div className="w-full bg-white pb-[68px] md:pb-0" data-id="element-246" data-mp="79wp69c0ajoe">
      <Header onFormCta={onFormCta} data-id="element-247" data-mp="77ahm9p48466" />

      <main data-id="element-248" data-mp="14or1ebeqp5nd">
        <Hero copy={copy} onFormCta={onFormCta} data-id="element-249" data-mp="14palnyrv464k" />
        <BenefitsSection onFormCta={onFormCta} data-id="element-250" data-mp="zxskpapua5jl" />
        <ControlSection onFormCta={onFormCta} data-id="element-251" data-mp="zx0n5ucolxqo" />
        <HowItWorks data-id="element-252" data-mp="1iu155y5nw1k2" />
        <TechnologySection onFormCta={onFormCta} data-id="element-253" data-mp="1itj14fcrcj1l" />
        <CredibilitySection data-id="element-254" data-mp="1iuszz6rfpv9a" />
        <LeadFormSection data-id="element-255" data-mp="1nt49fgdti3qz" />
        <FAQSection data-id="element-256" data-mp="1ntdsek0g3an6" />
        <FinalCTA onFormCta={onFormCta} data-id="element-257" data-mp="1nrsymwlyfvqd" />
      </main>

      <Footer data-id="element-258" data-mp="1a1z6a4b8qtbw" />

      {showStickyMobileCta && <StickyMobileCTA onFormCta={onFormCta} onBookCall={onBookCall} data-id="element-259" data-mp="1a0xws49viewa" />}
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} data-id="element-260" data-mp="1e2syh9vpuual" />
    </div>;
}